// ─────────────────────────────────────────────
// SET THESE VALUES ONCE — then leave this file alone
// Ask your Azure AD admin for these values
// ─────────────────────────────────────────────

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,   // Azure AD App Registration → Application (client) ID
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`, // Azure AD → Tenant ID
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    "Calendars.Read",
    "Files.Read.All",           // SharePoint files
    "Sites.Read.All",           // SharePoint sites
    "ChannelMessage.Read.All",  // Teams messages
  ],
};